import { render, staticRenderFns } from "./LocalesMenu.vue?vue&type=template&id=771b612c&scoped=true&"
import script from "./LocalesMenu.vue?vue&type=script&lang=ts&"
export * from "./LocalesMenu.vue?vue&type=script&lang=ts&"
import style0 from "./LocalesMenu.vue?vue&type=style&index=0&id=771b612c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b612c",
  null
  
)

export default component.exports